"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getMailboxJunkEmailConfigurationOperation_1 = require("owa-service/lib/operation/getMailboxJunkEmailConfigurationOperation");
function loadMailboxJunkEmailConfiguration() {
    return getMailboxJunkEmailConfigurationOperation_1.default().then(function (responseMessage) {
        if (responseMessage.WasSuccessful) {
            return responseMessage.Options;
        }
        else {
            throw new Error("getMailboxJunkEmailConfigurationOperation " + responseMessage.ErrorCode + " " + responseMessage.ErrorMessage);
        }
    });
}
exports.default = loadMailboxJunkEmailConfiguration;
//# sourceMappingURL=getMailboxJunkEmailConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-junkmail-configuration/lib/services/getMailboxJunkEmailConfiguration.js
// module id = 5024
// module chunks = 2